// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { init } from "aos"
init();


import * as bootstrap from "bootstrap"

class MiniJS {
  constructor() {
    this.init();
  }

  init() {
    // Naslouchání pro akce kliknutí
    document.addEventListener("click", (event) => {
      const target = event.target.closest("[data-action]");
      if (target) {
        event.preventDefault();
        this.handleAction(target);
      }
    });

    // Naslouchání pro pohyb myši pro paralax efekt
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
  }

  handleAction(target) {
    const action = target.dataset.action;
    const selector = target.dataset.target;
    if (!selector) return;
    const elements = document.querySelectorAll(selector);

    switch (action) {
      case "toggle":
        this.toggle(elements);
        break;
      case "slide":
        this.slide(elements, target); // Předáme target tlačítka
        break;
      case "animate":
        this.animate(elements);
        break;
      case "show":
        this.show(elements);
        break;
      case "hide":
        this.hide(elements);
        break;
      case "zoom":
        this.zoom(elements);
        break;
      case "parallax":
        this.parallax(elements); // Nová akce pro paralax
        break;
      default:
        console.warn(`Neznámá akce: ${action}`);
    }
  }

  // Metoda pro paralax efekt
  handleMouseMove(event) {
    // Získání všech prvků, které mají atribut data-parallax
    const parallaxElements = document.querySelectorAll("[data-parallax]");

    parallaxElements.forEach((element) => {
      this.applyParallaxEffect(element, event);
    });
  }

  applyParallaxEffect(element, event) {
    const rect = element.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // Pohyb myši vzhledem k centru elementu
    const moveX = (event.clientX - centerX) / 10;
    const moveY = (event.clientY - centerY) / 10;

    // Aplikace transformace pro paralax efekt
    element.style.transform = `translate(${moveX}px, ${moveY}px)`;
  }

  toggle(elements) {
    elements.forEach((el) => el.classList.toggle("d-none"));
  }

  slide(elements, button) {
    elements.forEach((el) => {
      el.classList.toggle("open");
    });
    this.toggleActiveButton(button);
  }

  animate(elements) {
    elements.forEach((el) => {
      gsap.to(el, { opacity: 1, y: 0, duration: 0.5 });
    });
  }

  show(elements) {
    elements.forEach((el) => {
      el.classList.remove("d-none", "fade-out");
      el.classList.add("fade-in");
    });
  }

  hide(elements) {
    elements.forEach((el) => {
      el.classList.add("fade-out");
      el.classList.remove("fade-in");

      setTimeout(() => el.classList.add("d-none"), 150);
    });
  }

  zoom(elements) {
    elements.forEach((el) => {
      const overlay = document.createElement("div");
      overlay.classList.add("overlay");
      document.body.appendChild(overlay);

      const clone = el.cloneNode();
      clone.classList.add("zoomed");
      overlay.appendChild(clone);

      overlay.addEventListener("click", () => {
        overlay.remove();
      });
    });
  }

  toggleActiveButton(currentButton) {
    currentButton.classList.toggle("active");
  }
}

// Iniciace frameworku
document.addEventListener("DOMContentLoaded", () => new MiniJS());


  